export default __webpack_public_path__ + "static/media/18.7bc25684.jpg";